var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCameraFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12 8.857a3.929 3.929 0 1 0 0 7.858 3.929 3.929 0 0 0 0-7.858"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M9.218 2.646q2.781-.15 5.565 0a3.08 3.08 0 0 1 2.443 1.456l.86 1.38a1.64 1.64 0 0 0 1.163.743q.606.086 1.206.186C21.955 6.66 23 7.975 23 9.458v8.828a3.143 3.143 0 0 1-3.143 3.142H4.143A3.143 3.143 0 0 1 1 18.287V9.458c0-1.483 1.044-2.797 2.545-3.047q.6-.1 1.205-.187a1.63 1.63 0 0 0 1.163-.743l.861-1.378a3.08 3.08 0 0 1 2.444-1.457M6.5 12.786a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0m12.571-1.572a.786.786 0 1 0 0-1.571.786.786 0 0 0 0 1.571",
  clipRule: "evenodd"
})));
export default SvgCameraFill;